(function($,undefined){
    var
        def={
            stuckClass:'isStuck'
        },
        doc=$(document);

    $.fn.TMStickUp=function(opt){
        opt = $.extend(true,{},def,opt);

        $(this).each(function(){
            var $this = $(this),
                posY,
                isStuck = false,
                clone = $this.clone().appendTo($this.parent()).addClass(opt.stuckClass),
                height,
                stuckedHeight = clone.outerHeight(),
                tmr;

            $(window).resize(function(){
                clearTimeout(tmr);
                clone.css({top:isStuck?0:-stuckedHeight,visibility:isStuck?'visible':'hidden'});
                tmr=setTimeout(function(){
                    posY=$this.offset().top;
                    height=$this.outerHeight();
                    stuckedHeight=clone.outerHeight();

                    clone.css({top:isStuck?0:-stuckedHeight});
                },40);
            }).resize();

            clone.css({
                position:'fixed',
                width:'100%'
            });

            doc.on('scroll',function(){
                    var scrollTop=doc.scrollTop();

                    if(scrollTop>posY&&!isStuck){
                        clone.off('webkitTransitionEnd oTransitionEnd transitionend webkitAnimationEnd oAnimationEnd animationend');
                        clone.css({
                                visibility: 'visible',
                                top: 0
                            });

                        isStuck=true;
                        $('body').addClass('stuck-menu-shown');
                    }

                    if(scrollTop<=posY+height&&isStuck){
                        clone.on('webkitTransitionEnd oTransitionEnd transitionend webkitAnimationEnd oAnimationEnd animationend', function (e) {
                            clone.css({
                                visibility: 'hidden'
                            });
                            clone.off('webkitTransitionEnd oTransitionEnd transitionend webkitAnimationEnd oAnimationEnd animationend');
                        });
                        clone.css({
                            top:-stuckedHeight
                        });

                        isStuck=false;
                        $('body').removeClass('stuck-menu-shown');
                    }
                });

            setTimeout(function () {
                doc.trigger('scroll');
            }, 50);
        });
    };
})(jQuery);
